export default "__VITE_ASSET__DPw$TT3M__"